import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'urql'
import { Customer } from '../../../gql/graphql'
import { compact } from '../../_helpers/compact'
import { publicFestivalsQuery } from '../../_lib/graphql/queries'
import { Spinner } from '../../_ui'
import { FestivalCard } from '../FestivalCard'
import { PublicLayout } from '../PublicLayout'

export const PublicFestivalsPage = () => {
  const [{ data, fetching }] = useQuery({ query: publicFestivalsQuery })

  const festivals = useMemo(() => compact(data?.publicFestivals) as Customer[], [data?.publicFestivals])

  return (
    <PublicLayout>
      <div className={'mt-6 mb-12 max-w-2xl'}>
        <h1 className={'text-4xl font-bold tracking-tight text-primary-200 text-balance sm:text-5xl'}>
          Festivals, die von Menschen wie dir getragen werden
        </h1>
        <p className={'mt-4 text-base leading-7 text-gray-600'}>
          Entdecke unsere Festivals, registriere dich und werde Teil der Crew.
        </p>
      </div>

      {fetching && !data && <Spinner />}
      {!fetching && festivals.length === 0 && (
        <p className={'rounded-2xl border border-dashed border-sand-200 bg-white/60 px-5 py-8 text-center text-sm text-gray-600'}>
          Zurzeit werden keine Festivals vorgestellt.
        </p>
      )}
      <div className={'grid gap-6 sm:grid-cols-2 lg:grid-cols-3'}>
        {festivals.map(festival => (
          <FestivalCard
            key={festival.id}
            festival={festival}
            actions={(
              <Link
                to={`/festivals/${festival.slug}`}
                className={'inline-flex items-center justify-center rounded-full bg-primary-200 px-6 py-2.5 text-sm font-semibold text-white hover:bg-primary-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
              >
                Details ansehen
              </Link>
            )}
          />
        ))}
      </div>
    </PublicLayout>
  )
}
